import React from 'react';

export function AddTaskForm({ canEdit, handleAdd }) {
  if (!canEdit) return null;

  return (
    <form onSubmit={handleAdd} className="form-row">
      <input
        name="order_number"
        placeholder="Numéro de commande"
        required
        style={{ height: '30px', fontSize: '16px', padding: '6px', width: '280px' }}
      />
      <input
        name="city"
        placeholder="Ville"
        required
        style={{ height: '30px', fontSize: '16px', padding: '6px', width: '180px' }}
      />
      <input
        name="weight"
        placeholder="Poids (kg)"
        required
        type="number"
        step="0.01"
        min="0"
        style={{ height: '30px', fontSize: '16px', padding: '6px', width: '120px' }}
      />
      <input
        name="note"
        placeholder="Note"
        style={{ height: '30px', fontSize: '16px', padding: '6px', width: '180px' }}
      />
      <button type="submit" style={{ height: '30px', fontSize: '16px', padding: '0 12px' }}>
        Ajouter
      </button>
    </form>
  );
}
